<template>
    <div>
        <el-form :model="form" label-position="right" label-width="100px">
            <!--            <el-form-item label="任职机构:" class="itemForm">-->
            <!--                <el-input :model="form.id" style="width: 350px;" placeholder="请输入任职机构"></el-input>-->
            <!--                <p class="formStatic">比如“清华大学”</p>-->
            <!--            </el-form-item>-->
            <el-form-item label="任职机构:" class="itemForm" style="margin-bottom: 1.2em;" :required="true">
                <sub-school @getSchoolId="fetchSchoolId" :selected-school-name="schoolName"
                            style="width: 350px;"></sub-school>
            </el-form-item>
            <el-form-item label="个人职称:" class="itemForm" style="margin-bottom: 1.4em;" prop="rank" :rules="[{
                required: true,
                message: '请输入职称，比如“教授”',
                trigger: 'blur'
            }]">
                <el-input v-model="form.rank" style="width: 350px;" placeholder="请输入职称"></el-input>
            </el-form-item>
            <el-form-item label="个人简介:" prop="intro" :rules="[{
                required: true,
                message: '请输入简介',
                trigger: 'blur'
            }]">
                <el-input v-model="form.intro" style="width: 350px;" type="textarea" :rows="5" placeholder="请输入个人简介">
                </el-input>
            </el-form-item>
            <el-form-item label="申请理由:" prop="reason" :rules="[{
                required: true,
                message: '请输入理由',
                trigger: 'blur'
            }]">
                <el-input v-model="form.reason" style="width: 350px;" type="textarea" :rows="5" placeholder="请输入申请理由">
                </el-input>
            </el-form-item>
            <el-form-item label="资格证书上传:">
                <div>
                    <div>
                        <el-upload :action="uploadUrl" :before-upload="uploadBefore" :on-success="uploadSuccessOne"
                                   :show-file-list="false">
                            <el-button slot="trigger" type="primary" size="mini">点击上传</el-button>
                        </el-upload>
                    </div>
                    <div class="colDesc">
                        <p>1、请上传有效期内的资格证照片能证明您行业能力的资格证书，如：教师资格证、高学历证、专业证书、其他；</p>
                        <p>2、可选择一个或多个上传，文件小于2M，格式支持jpg、png。</p>
                    </div>
                </div>
                <ul style="width: 650px;list-style: none;margin:0;padding:0;">
                    <li style="width: 200px;float:left;margin-right:15px;margin-top: 1em;"
                        v-for="(img, key) in imgCredentials" :key="key+Math.random()">
                        <sub-img :url="img" @delete="removeCer(img)"></sub-img>
                    </li>
                </ul>
            </el-form-item>
            <el-form-item label="承诺书上传:">
                <div>
                    <el-upload :action="uploadUrl" :before-upload="uploadBefore" :on-success="uploadSuccessTwo"
                               :show-file-list="false">
                        <el-button slot="trigger" type="primary" size="mini">点击上传</el-button>
                        <span style="color: #00a4e0;margin-left: 2em;cursor: pointer;" @click="down"><i
                            class="iconfont icon-download"></i>下载承诺书</span>
                    </el-upload>
                </div>
                <div class="colDesc">
                    <p>1、上传带有签名的“承诺书扫描件”</p>
                    <p>2、文件小于2M，支持jpg、png、格式</p>
                </div>
                <ul style="width: 650px;list-style: none;margin:0;padding:0;">
                    <li style="width: 200px;float:left;margin-right:15px;margin-top: 1em;"
                        v-for="(img, key) in imgPromise" :key="key+Math.random()">
                        <sub-img :url="img" @delete="removeCre(img)"></sub-img>
                    </li>
                </ul>
            </el-form-item>
            <el-form-item>
                <div>
                    <el-button type="primary" size="mini" style="width: 100px;" @click="doPre()" plain="plain"
                               v-if="preUrl">上一步
                    </el-button>
                    <el-button type="primary" size="mini" style="width: 150px;" @click="doNext()" v-if="nextUrl">
                        下一步，申请学校
                    </el-button>
                    <el-button type="primary" size="mini" style="width: 150px;margin-left: 100px;" @click="doOut()"
                               plain="plain" v-if="outUrl">
                        不申请学校，直接退出
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <div v-if="saveUrl" style="text-align: center;">
            <el-button type="primary" size="mini" style="width: 100px" @click="doSave">确认上传</el-button>
        </div>
        <el-dialog title="提示" :visible.sync="outDialog" width="550px">
            <p>您还未加入学校，直接提交审核？</p>
            <p>审核通过后，可在用户中心自主加入学校</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" plain="plain" @click="doOutCancel()">我再想想</el-button>
                <el-button type="primary" @click="doOutCommit()">确认提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import SubImg from './SubImg'
import SubSchool from './SubSchool'

export default {
    name: 'SubTeacherInfo',
    components: {
        SubImg,
        SubSchool
    },
    props: ['pre', 'next', 'out', 'save'],
    created () {
        this.preUrl = this.pre
        this.nextUrl = this.next
        this.outUrl = this.out
        this.saveUrl = this.save
        this.init()

        console.log(this.pre, this.next, this.out, this.save, this.saveUrl)
    },
    data () {
        return {
            form: {
                rank: '',
                intro: '',
                reason: ''
            },
            outDialog: false,
            preUrl: '',
            nextUrl: '',
            outUrl: '',
            saveUrl: '',
            schoolId: 0,
            schoolName: '',
            imgPromise: [],
            imgCredentials: [],
            uploadUrl: '',
            //预览图片地址
            viewImgUrl: '',
            isShowView: false,
            id: 0
        }
    },
    methods: {
        init () {
            this.uploadUrl = localStorage.getItem('ServerUrl') + '/api/file/uploadfile'
            this.getApplyData()
        },
        getApplyData () {
            let that = this
            this.$ajax.get('/api/teacher/getbyuid').then(function (res) {
                if (!that.isEmpty(res.data)) {
                    that.id = res.data.id
                    that.schoolId = res.data.school_id
                    that.schoolName = res.data.school_name
                    that.form.rank = res.data.rank
                    that.form.intro = res.data.intro
                    that.form.reason = res.data.reason
                    that.imgPromise = res.data.promise
                    that.imgCredentials = res.data.credentials
                }
            })
        },
        doPre: function () {
            this.$router.push({
                path: this.preUrl
            })
        },
        doCommit (url) {
            //提交数据
            if (this.isEmpty(this.schoolId)) {
                this.showError('请选择学校')
                return
            }
            //职称
            if (this.isEmpty(this.form.rank)) {
                this.showError('请输入职称')
                return
            }
            if (this.isEmpty(this.form.intro)) {
                this.showError('请输入简介')
                return
            }
            if (this.isEmpty(this.form.reason)) {
                this.showError('请输入申请理由')
                return
            }
            if (this.isEmpty(this.imgCredentials)) {
                this.showError('请上传资格证书')
                return
            }
            if (this.isEmpty(this.imgPromise)) {
                this.showError('请上传承诺书')
                return
            }
            let that = this
            let postUrl = '/api/teacher/create'
            let params = {
                school_id: this.schoolId,
                rank: this.form.rank,
                intro: this.form.intro,
                reason: this.form.reason,
                credentials: this.imgCredentials,
                promise: this.imgPromise
            }
            if (this.id > 0) {
                params.id = this.id
                postUrl = '/api/teacher/update'
            }
            this.$ajax.post(postUrl, params).then(function (res) {
                that.$message.success('保存成功')
                setTimeout(function () {
                    that.$router.push({
                        path: url
                    })
                }, 2000)
            })
        },
        doNext: function () {
            this.doCommit(this.nextUrl)
        },
        doOut: function () {
            this.outDialog = true
        },
        doOutCancel: function () {
            this.outDialog = false
        },
        doOutCommit: function () {
            this.outDialog = false
            let url = this.outUrl
            if (url.indexOf('?') !== -1) {
                url += '&addSchool=0'
            } else {
                url += '?addSchool=0'
            }
            this.doCommit(url)
        },
        doSave () {
            this.doCommit(this.saveUrl)
        },
        removeCer (url) {
            //循环删掉
            let img = this.imgCredentials
            this.imgCredentials = []
            for (let i = 0; i < img.length; i++) {
                if (img[i] !== url) {
                    this.imgCredentials.push(img[i])
                }
            }
            this.$message.success('删除成功')
        },
        removeCre (url) {
            //循环删掉
            let img = this.imgPromise
            this.imgPromise = []
            for (let i = 0; i < img.length; i++) {
                if (img[i] !== url) {
                    this.imgPromise.push(img[i])
                }
            }
            this.$message.success('删除成功')
        },
        //获取选中的学校id
        fetchSchoolId: function (id) {
            this.schoolId = id
        },
        uploadBefore (file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                this.showError('只能是jpg或png格式')
                return false
            }
            if (file.size > 2 * 1024 * 1024) {
                this.showError('图片大小不能超过2MB')
                return false
            }
            return true
        },
        imgView (file) {
            this.viewImgUrl = file
            this.isShowView = true
        },
        uploadSuccessOne (res) {
            this.imgCredentials.push(localStorage.getItem('ServerUrl') + res.data.file)
        },
        uploadSuccessTwo (res) {
            this.imgPromise.push(localStorage.getItem('ServerUrl') + res.data.file)
        },
        down () {
            console.log('down')
            let a = document.createElement('a')
            a.href = './../user/cheng_nuo_shu.docx'
            let d = new Date()
            let fileName = d.getFullYear() + this.dateAddZero(d.getMonth() + 1) + this.dateAddZero(d.getDate()) + this.dateAddZero(d.getHours()) + this.dateAddZero(d.getMinutes()) + this.dateAddZero(d.getSeconds())
            a.download = '承诺书_' + fileName + '.docx'
            a.click()
        }
    }
}
</script>

<style>
.colDesc {
    font-size: 12px;
    color: #999999;
}

.colDesc p {
    padding: 0;
    margin: 0;
    line-height: 25px;
}

.formStatic {
    font-size: 12px;
    padding: 0;
    margin: 0;
    line-height: 25px;
    color: #999999;
}

</style>



// WEBPACK FOOTER //
// src/components/public/sub/SubTeacherInfo.vue